/* eslint-disable no-undef */
import { memo, useEffect } from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import {
  RegisteredEventName,
  broadcastToParent,
} from '@finanzcheck/catalyst-pollard'

import Page from '../../../components/page/Page'

import useEmbedObject, {
  IMOD_CONTAINER_ID,
} from '../../../hooks/useEmbedObject'
import theme, { SupportedTheme } from '../../../theme'
import {
  initPollardCommunication,
  broadcastChildFrameData,
} from '../../../utils/pollard'
import { getPaletteFromQueryParams } from '../../../utils/theme.utils'
import useUrlParams from '../../../hooks/useUrlParams'
import { getDacFormConfig } from '../../../utils/getTenantInfo.utils'

const Base = () => {
  theme.name = SupportedTheme.Embedded

  const { palette, backUrl, paapiId, hasDac } = useUrlParams()

  const embedObject = useEmbedObject({
    ...(hasDac === 'true' && { formConfig: getDacFormConfig() }),
    palette: getPaletteFromQueryParams(palette as string),
  })

  const isBankListFlow = backUrl?.includes('banklist')

  useEffect(() => {
    initPollardCommunication()
    broadcastChildFrameData()

    teal_embed_iframe(embedObject)
    delete embedObject.data.resume

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [palette])

  useEffect(() => {
    if (isBankListFlow) {
      broadcastToParent({
        eventName: RegisteredEventName.tracking,
        data: {
          event: '/affiliate:bankpartner',
          advertisementId: embedObject.advertisementId,
          refId: embedObject.refId,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (paapiId) {
      broadcastToParent({
        eventName: RegisteredEventName.tracking,
        data: {
          event: '/affiliate:api',
          advertisementId: embedObject.advertisementId,
          refId: embedObject.refId,
        },
      })
    }
  }, [paapiId])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Page hasHeader={false} extendedFooter={false}>
        <div id={IMOD_CONTAINER_ID} />
      </Page>
    </ThemeProvider>
  )
}

export default memo(Base)
